/**
 * A marca: logo em SVG e o lockup com "Store" + "LUMMA SOFTWARE".
 *
 * O SVG é o do handoff, ponto a ponto. O segundo traço é o "risco de luz" e
 * não é decoração descartável — sem ele a logo perde o volume que o designer
 * desenhou.
 */
import { useId } from 'react'

type Variante = 'claro' | 'escuro'

export function Logo({
  tamanho = 34,
  variante = 'claro',
}: {
  tamanho?: number
  variante?: Variante
}) {
  // O gradiente precisa de id único: duas logos na mesma página com o mesmo id
  // fazem a segunda herdar o gradiente da primeira.
  const idGradiente = useId()

  const [inicio, fim] = variante === 'escuro' ? ['#FFFFFF', '#93C5FD'] : ['#60A5FA', '#2563EB']
  const risco = variante === 'escuro' ? '#FFFFFF' : '#93C5FD'
  const opacidadeRisco = variante === 'escuro' ? 0.6 : 1

  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Lumma Store"
    >
      <defs>
        <linearGradient id={idGradiente} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={inicio} />
          <stop offset="1" stopColor={fim} />
        </linearGradient>
      </defs>
      <path
        d="M14.5 8.5v16.5a13.5 13.5 0 0 0 13.5 13.5h11.5"
        fill="none"
        stroke={`url(#${idGradiente})`}
        strokeWidth="8.6"
        strokeLinecap="round"
      />
      <path
        d="M11.6 5.6v16.5a13.5 13.5 0 0 0 13.5 13.5h11.5"
        fill="none"
        stroke={risco}
        strokeOpacity={opacidadeRisco}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function Lockup({
  tamanhoLogo = 34,
  tamanhoTexto = 24,
  variante = 'claro',
  comSublabel = true,
}: {
  tamanhoLogo?: number
  tamanhoTexto?: number
  variante?: Variante
  comSublabel?: boolean
}) {
  return (
    <div className="flex items-center gap-3">
      <Logo tamanho={tamanhoLogo} variante={variante} />
      <div>
        <div
          className={`font-marca font-bold leading-[1.05] ${
            variante === 'escuro' ? 'text-white' : 'text-titulo'
          }`}
          style={{ fontSize: tamanhoTexto }}
        >
          Store
        </div>
        {comSublabel && (
          <div className="mt-[3px] text-[10.5px] font-semibold tracking-[1.4px] text-texto-fraco">
            LUMMA SOFTWARE
          </div>
        )}
      </div>
    </div>
  )
}
